import { AppEnvEnum, appConfig } from '@ll-platform/frontend/config/app.config';

const FaviconUrlMap: Record<AppEnvEnum, string> = {
  [AppEnvEnum.Production]: '/favicon-production.ico',
  [AppEnvEnum.Staging]: '/favicon-staging.ico',
  [AppEnvEnum.Development]: '/favicon-development.ico',
  [AppEnvEnum.E2E]: '/favicon-e2e.ico',
};

export function Favicon() {
  const faviconUrl = FaviconUrlMap[appConfig.REACT_APP_ENV];

  return <link rel="icon" type="image/x-icon" href={faviconUrl} />;
}
